module.exports = __webpack_public_path__ + "img/couples_04_V.86169e26.webp";